export default __webpack_public_path__ + "0e9d83454817ab2d7c08a41c08f52821.svg";